import React from 'react'
import { Box, Spinner } from '@ally/metronome-ui'
import styled from 'styled-components'

const SpinnerWrapper = styled(Box)`
  width: 100%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`
interface ComponentProps {
  testId?: string
  altText?: string
}

const LoadingSpinner: React.VFC<ComponentProps> = ({
  testId,
  altText = "We're loading your information",
}) => {
  return (
    <SpinnerWrapper data-testid={testId}>
      <Spinner altText={altText} />
    </SpinnerWrapper>
  )
}

export default LoadingSpinner
